import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';

import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

export type CartBadgeProps = BadgeProps & {
  className?: string;
};
// TODO: fix styling on long texts ?
export function CartBadge({ className, ...props }: CartBadgeProps) {
  const me = useCustomerStore(state => state.me);
  const { data: cart } = useQuery({ ...useCartQueryOpts(), enabled: !!me?.authToken });

  if (!cart?.count) return null;

  const countText =
    cart?.count > 99 ? (
      <span>
        99<sup>+</sup>
      </span>
    ) : (
      cart?.count
    );

  return (
    <Badge
      className={cn(
        'absolute -right-2 -top-2 flex max-h-4 min-h-4 min-w-4 max-w-4 items-center justify-center rounded-full bg-primary text-center text-[10px] text-white',
        'ea-cart-button__badge',
        className,
      )}
      size="circle"
      variant="destructive"
      {...props}
    >
      {countText}
    </Badge>
  );
}
